module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/waf-2015-08-24.paginators.json
// module id = 526
// module chunks = 0